// components/copilot/utils/attachments.js
export const isImageAttachment = (a) => {
  const ct = String(a?.content_type || "").toLowerCase();
  return !!a?.is_image || ct.startsWith("image/");
};
